import React from 'react';

import {
  useMoveCourseOverviewItemMutation,
  useUpdateCourseContentMutation,
} from '../../my-courses/coursesApi';

import { OverviewCard } from './OverviewCard';

import type { Course } from '@/shared/types/course';
import type { OverviewItem } from '@/shared/types/overview';
import type { ReorderPlacement } from '@/shared/utils/reorder';

interface CourseOverviewCardProps {
  course: Course;
  canEdit: boolean;
}

export const CourseOverviewCard: React.FC<CourseOverviewCardProps> = ({ course, canEdit }) => {
  const [updateCourseContent, { isLoading: isUpdating }] = useUpdateCourseContentMutation();
  const [moveOverviewItem] = useMoveCourseOverviewItemMutation();

  const handleMoveOverviewItem = (itemId: string, placement: ReorderPlacement) =>
    moveOverviewItem({ courseId: course.id, itemId, placement }).unwrap();

  const handleSaveOverview = async (overview: OverviewItem[]) => {
    await updateCourseContent({
      id: course.id,
      content: {
        overview,
        schemaVersion: '1',
      },
    }).unwrap();
  };

  return (
    <OverviewCard
      title="Course Overview"
      entityName="course"
      items={course.content?.overview ?? []}
      canEdit={canEdit}
      isUpdating={isUpdating}
      onSave={handleSaveOverview}
      onMove={handleMoveOverviewItem}
      ownerId={course.owner_id}
      allowAllToggle={false}
      sx={{ mb: 3 }}
    />
  );
};
